import React from "react";
import { useLanguage } from "../../../../contexts";
import { P, useEnergia } from "../engine";
import { ConInstalacion, Section, StatusBadge } from "../common/SectionCommon";
import "../common/common.scss";

const PRIORIDAD = { Alta: "Brecha mayor", Media: "Brecha parcial", Baja: "Mejorable" };

// Plan de brechas y hoja de ruta por fases de implementación (hoja 18; hoja 01 filas 39, 129).
export function GapPlan({ installation }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const vista = useEnergia(installation);
  return (
    <ConInstalacion installation={installation} vista={vista} t={t}>
      {(f) => {
        const plan = P.planDeBrechas(f);
        const ruta = P.hojaDeRuta(f);
        return (
          <div className="ep-screen">
            <h3 className="ep-screen__title">{t("energy_performance_gaps_title")}</h3>
            <p className="ep-screen__intro">{t("energy_performance_gaps_intro")}</p>

            <Section title={t("energy_performance_gaps_plan")} note={t("energy_performance_gaps_plan_note")}>
              {plan.length ? (
                <div className="ep-table">
                  <table>
                    <thead><tr><th>{t("energy_performance_priority")}</th><th>{t("energy_performance_clause")}</th><th>{t("energy_performance_ecm_status")}</th><th>{t("energy_performance_finding")}</th><th>{t("energy_performance_gaps_to_load")}</th><th>{t("energy_performance_gaps_owner")}</th></tr></thead>
                    <tbody>
                      {plan.map((b, i) => (
                        <tr key={i}>
                          <td><StatusBadge estado={PRIORIDAD[b.prioridad] || "Pendiente"}>{b.prioridad}</StatusBadge></td>
                          <td className="ep-mono">{b.cl}</td>
                          <td><StatusBadge estado={P.LBL_VIS[b.estado] || b.estado} /></td>
                          <td className="ep-section__note">{b.hallazgo}</td>
                          <td>{b.cargar}</td>
                          <td className="ep-section__note">{b.resp}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : <p><StatusBadge estado="Cumple">{t("energy_performance_gaps_none")}</StatusBadge></p>}
            </Section>

            <Section title={t("energy_performance_roadmap_title")} note={t("energy_performance_roadmap_note")}>
              {!ruta.fases.length && <p><StatusBadge estado="Cumple">{t("energy_performance_gaps_none")}</StatusBadge></p>}
              {ruta.fases.map((p) => (
                <div key={p.n} className="ep-roadmap__phase">
                  <p><StatusBadge estado="Pendiente">{t("energy_performance_phase")} {p.n} — {p.t}</StatusBadge> <span className="ep-section__note">{p.items.length} {t("energy_performance_items")}</span></p>
                  <ul>
                    {p.items.map((b, i) => <li key={i}><strong>{b.cl}:</strong> {b.cargar} <span className="ep-section__note">({b.resp})</span></li>)}
                  </ul>
                </div>
              ))}
            </Section>
          </div>
        );
      }}
    </ConInstalacion>
  );
}
